<template>
    <CCard>    
        <CCardBody>  
            <CRow>
                <div class="col-lg-12 d-flex align-items-center">
                    <label style="margin-right: 10px; font-weight: bold; width: 80px;" >手機類型:</label>
                    <ejs-dropdownlist width="100px" id='dropdownlist' :dataSource='HeaderData' :fields="fields" v-model="e_header" @change="Query"></ejs-dropdownlist>
                    &nbsp;&nbsp;&nbsp;&nbsp;                    
                    <label style="margin-right: 10px; font-weight: bold; width: 80px;" >線上版號:</label>
                    <ejs-textbox width="40px" style="text-align: center;" id="Major" floatLabelType="Auto"  placeholder="" v-model="e_major_no"  ></ejs-textbox>.
                    <ejs-textbox width="40px" style="text-align: center;" id="Minor" floatLabelType="Auto"  placeholder="" v-model="e_minor_no" ></ejs-textbox>
                    &nbsp;&nbsp;&nbsp;&nbsp;

                    <label style="margin-right: 10px;margin-left: 10px; font-weight: bold; width: 40px;">類型:</label>
                    <ejs-dropdownlist width="100px" id='dropdownlist' :dataSource='LanguageData' :fields="fields" v-model="e_languge"  @change="Query"></ejs-dropdownlist>
                        &nbsp;&nbsp;&nbsp;
                    <ejs-button cssClass='e-primary' @click.native="Upload">儲存</ejs-button>
                </div>               
                
            </CRow>
            <hr>
            <CRow sm="12" lg="12" >
                <CCol sm="12" lg="12" >     
                  重大版本不同時,顯示內容<span style="color:red">*Android啟動訊息背景為透明黑色底</span>   
                </CCol>
            </CRow> 
            <CRow sm="12" lg="12" >
                <CCol sm="6" lg="6" style="padding-left: 0px; padding-right: 0px; padding-top: 10px;">            
                    <div class="container">
                      
                        <div class="editor-wrapper-2" ref="editorMajorContainer" ></div>                     
                    </div>
                
                </CCol>
                <CCol sm="6" lg="6" style="padding-left: 0px; padding-right: 0px; padding-top: 10px;">                   
                    <div class="container">
                        <div class="preview-wrapper-2">
                        <iframe :srcdoc="e_major_html" style="width: 100%;" frameborder="0"></iframe>
                        </div>
                    </div>                  
                </CCol>                           
            </CRow>
            <hr>
            <CRow sm="12" lg="12" >
                <CCol sm="12" lg="12" >     
                  次要版本不同時,顯示內容<span style="color:red">*Android啟動訊息背景為透明黑色底</span>
                </CCol>
            </CRow> 
            <CRow sm="12" lg="12" >
                <CCol sm="6" lg="6" style="padding-left: 0px; padding-right: 0px; padding-top: 10px;">            
                    <div class="container">      
                        <div class="editor-wrapper-2" ref="editorMinorContainer" ></div>                     
                    </div>
                
                </CCol>
                <CCol sm="6" lg="6" style="padding-left: 0px; padding-right: 0px; padding-top: 10px;">                   
                    <div class="container">
                        <div class="preview-wrapper-2">
                        <iframe :srcdoc="e_minor_html" style="width: 100%;" frameborder="0"></iframe>
                        </div>
                    </div>                  
                </CCol>                           
            </CRow>
            <hr>
            <CRow sm="12" lg="12" >
                <CCol sm="12" lg="12" >     
                  一般訊息,顯示內容<span style="color:red">*Android啟動訊息背景為透明黑色底</span>
                </CCol>
            </CRow> 
            <CRow sm="12" lg="12" >
                <CCol sm="6" lg="6" style="padding-left: 0px; padding-right: 0px; padding-top: 10px;">           
                    <div class="container">                      
                        <div class="editor-wrapper-2" ref="editorGeneralContainer" ></div>                     
                    </div>
                
                </CCol>
                <CCol sm="6" lg="6" style="padding-left: 0px; padding-right: 0px; padding-top: 10px;">                   
                    <div class="container">
                        <div class="preview-wrapper-2">
                        <iframe :srcdoc="e_general_html" style="width: 100%;" frameborder="0"></iframe>
                        </div>
                    </div>                  
                </CCol>                           
            </CRow>
        </CCardBody>
    </CCard>  
</template>
<script>
import Vue from "vue";

import Quill from 'quill'

// 引入樣式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill-better-table/dist/quill-better-table.css'

import CodeMirror from 'codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/theme/material.css'
import 'codemirror/addon/edit/matchbrackets.js'

// 引入模組
import QuillBetterTable from 'quill-better-table'

// 註冊 module
Quill.register(
  {
    'modules/better-table': QuillBetterTable
  },
  true
)


import { DropDownListComponent } from '@syncfusion/ej2-vue-dropdowns';
import { ButtonComponent } from '@syncfusion/ej2-vue-buttons';
import Loading from 'vue-loading-overlay';

Vue.use(Loading);
let Loader = undefined;
export default Vue.extend({ 
   
    components: {
        "ejs-dropdownlist": DropDownListComponent,
        "ejs-button": ButtonComponent, 
    },
    data: function() {
        return {
        
            e_major_editor: null,
            e_minor_editor: null,
            e_general_editor: null,
            e_languge:'TW',
            e_header:'Android',
            e_major_no: '',
            e_minor_no: '',
            e_major_html: '',
            e_minor_html: '',
            e_general_html: '',
            //vue quill
            //DownList
            fields: { text: 'text', value: 'value' },
            HeaderData: [
                { value: 'Android', text: 'Android' },
                { value: 'IOS', text: 'IOS' }               
            ],          
            LanguageData:[
                { value: 'TW', text: '繁體' },
                { value: 'CN', text: '簡體' },
                { value: 'en', text: '英文' },
                { value: 'ja', text: '日文' },
                { value: 'th', text: '泰語' },
            ],
            editorOption: {
                theme: 'snow',
                table: true, // 啟用 Quill 內建 table module
                modules: {
                    toolbar: {
                        container: [
                        ['bold', 'italic', 'underline', 'strike'], // toggled buttons 
                        ['blockquote', 'code-block'], 
                        
                        [{ 'header': 1 }, { 'header': 2 }], // custom button values 
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }], 
                        [{ 'script': 'sub'}, { 'script': 'super' }], // 升冪與降冪
                        [{ 'indent': '-1'}, { 'indent': '+1' }], // 縮排與減少縮排
                        [{ 'direction': 'rtl' }], // text direction 
                        
                        [{ 'size': ['small', false, 'large', 'huge'] }], // custom dropdown 
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }], 
                        
                        [{ 'color': [] }, { 'background': [] }], // dropdown 從 theme 獲取預設值 
                        [{ 'font': [] }], 
                        [{ 'align': [] }], 
                        
                        ['clean'], // 移除格式 
                        ['table'] // <-- 加入表格按鈕

                        ],
                        handlers: {
                            table() {
                                alert('12313');
                                const tableModule = this.quill.getModule('better-table')
                                tableModule.insertTable(3, 3) // 預設插入 3x3 表格
                            }
                        }
                    },                    
                },
                 
            }
        }
    },
    created(){
        this.Query();
    },
    methods: {
        //component
        Query(){
            console.log(`${this.e_header}_${this.e_languge}`);
            this.gethtml();
        },
        Upload(){
            console.log(`${this.e_header}_${this.e_languge}`);
            console.log(`${this.htmlContent}`);
            this.puthtml();
        },
        //api
        gethtml: function () {        
          this.showLoading();            
          this.axios({
            method: 'get',
            baseURL: Vue.prototype.GLOBAL.baseURL,
            url: `/AppManager/Version?id=${this.e_header}_${this.e_languge}`,
            headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          })
          .then((response) => {            
                this.hideLoading();   
                if (!response.data.ok) { this.$toast.open({message: response.data.msg, type: "error", duration: 5000, dismissible: true }) }
                this.e_major_html = response.data.datas.major_html;
                this.e_minor_html = response.data.datas.minor_html;
                this.e_general_html = response.data.datas.general_html;
                this.e_major_no = response.data.datas.major_no;
                this.e_minor_no = response.data.datas.minor_no;
                this.$refs.editor.quill.clipboard.dangerouslyPasteHTML(this.htmlContent);
            })
            .catch((error) => { this.showError(error, true) }
          )        
        },
        puthtml: function () {        
          this.showLoading();            
          this.axios({
            method: 'put',
            baseURL: Vue.prototype.GLOBAL.baseURL,
            url: `/AppManager/Version`,
            headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
            data:{
                id:`${this.e_header}_${this.e_languge}`,
                major_html:this.e_major_html,
                minor_html:this.e_minor_html,
                general_html:this.e_general_html,
                major_no:this.e_major_no,
                minor_no:this.e_minor_no,
            },
          })
          .then((response) => {            
            this.hideLoading();   
            this.$toast.open({message: "已修改完成", type: "success", duration: 5000, dismissible: true })
            if (!response.data.ok) { this.$toast.open({message: response.data.msg, type: "error", duration: 5000, dismissible: true }) }
               this.gethtml();
            })
            .catch((error) => { this.showError(error, true) }
          )        
        },
        showLoading() {
            Loader = this.$loading.show({
                    container: this.$refs.loadingContainer,
                    canCancel: true, // default false
                    onCancel: this.yourCallbackMethod,
                    color: 'green',
                    loader: 'dots',  // spinner, dots, bars
                    width: 164,
                    height: 164,
                    backgroundColor: 'black',
                    opacity: 0.5,
                    zIndex: 999,
                });
        },
        hideLoading() {
            Loader.hide();
        }
    },
    watch: {
    // 如果 data 改變，也同步更新編輯器（完全雙向）
        e_major_html(val) {
            if (this.e_major_editor && this.e_major_editor.getValue() !== val) {
                this.e_major_editor.setValue(val);
            }
        },
        e_minor_html(val) {
            if (this.e_minor_editor && this.e_minor_editor.getValue() !== val) {
                this.e_minor_editor.setValue(val);
            }
        },
        e_general_html(val) {
            if (this.e_general_editor && this.e_general_editor.getValue() !== val) {
                this.e_general_editor.setValue(val);
            }
        },
    },
    mounted() {
        // 初始化 CodeMirror
        this.e_major_editor = CodeMirror(this.$refs.editorMajorContainer, {
            value: this.e_major_html,
            mode: 'htmlmixed',
            theme: 'material',
            lineNumbers: true,
            matchBrackets: true,
            tabSize: 2,
            lineWrapping: true,
        })
        this.e_major_editor.getWrapperElement().id = "MajorEditor";
        this.e_major_editor.on('change', () => {
            this.e_major_html = this.e_major_editor.getValue()
        })

        this.e_minor_editor = CodeMirror(this.$refs.editorMinorContainer, {
            value: this.e_minor_html,
            mode: 'htmlmixed',
            theme: 'material',
            lineNumbers: true,
            matchBrackets: true,
            tabSize: 2,
            lineWrapping: true,
        })
        this.e_minor_editor.getWrapperElement().id = "MinorEditor";

        this.e_minor_editor.on('change', () => {
            this.e_minor_html = this.e_minor_editor.getValue()
        })

        
        this.e_general_editor = CodeMirror(this.$refs.editorGeneralContainer, {
            value: this.e_general_html,
            mode: 'htmlmixed',
            theme: 'material',
            lineNumbers: true,
            matchBrackets: true,
            tabSize: 2,
            lineWrapping: true,
        })

        this.e_general_editor.getWrapperElement().id = "GeneralEditor";
        this.e_general_editor.on('change', () => {
            this.e_general_html = this.e_general_editor.getValue()
        })
    }

})
</script>
<style>
 #textareaWrapper .e-multi-line-input {
    max-width: 100%;
 }
 /* 左邊編輯器 */
.editor-wrapper {
  height: 100%;
}

/* 右邊即時預覽 */
.preview-wrapper-2 {
  height: 100%;
}

.preview-wrapper-2 iframe {
  width: 100%;
  height: 200px;
  border-left: 1px solid #ccc;
}
#MajorEditor {
    height: 200px;
}
#MinorEditor {
    height: 200px;
}
#GeneralEditor {
    height: 200px;
}
</style>